var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NationalSystem',{attrs:{"title":"WDS","filter":r => r.notebook === 'WDS',"scan-results":_vm.scanResults}},[_vm._v(" A single WDS extract contains all daily national activity. This file was not received (so far) on this day. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }